




import Vue, { PropType } from "vue";
import VueApexCharts from "vue-apexcharts";
import { FieldDataTransitionsContent } from "@/features/coreWebVitals/types";

export default Vue.extend({
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    height: { type: Number, required: true },
    type: { type: String, required: true },
    chartData: {
      type: Object as PropType<FieldDataTransitionsContent>,
      required: true,
    },
  },
  data: () => ({
    series: [] as { name: string; type: string; data: (number | null)[] }[],
    options: {},
  }),
  created() {
    this.updateData();
  },
  methods: {
    updateData() {
      if (this.type === "fcp")
        this.series = [
          {
            name: "良好(<=1.8s)",
            type: "area",
            data: this.chartData.goodRate,
          },
          {
            name: "改善の余地あり",
            type: "area",
            data: this.chartData.needsImprovementRate,
          },
          {
            name: "不良(>3.0s)",
            type: "area",
            data: this.chartData.poorRate,
          },
          {
            name: "スコア",
            type: "bubble",
            data: this.chartData.score,
          },
        ];
      if (this.type === "lcp")
        this.series = [
          {
            name: "良好(<=2.5s)",
            type: "area",
            data: this.chartData.goodRate,
          },
          {
            name: "改善の余地あり",
            type: "area",
            data: this.chartData.needsImprovementRate,
          },
          {
            name: "不良(>4.0s)",
            type: "area",
            data: this.chartData.poorRate,
          },
          {
            name: "スコア",
            type: "bubble",
            data: this.chartData.score,
          },
        ];
      if (this.type === "cls")
        this.series = [
          {
            name: "良好(<=0.10)",
            type: "area",
            data: this.chartData.goodRate,
          },
          {
            name: "改善の余地あり",
            type: "area",
            data: this.chartData.needsImprovementRate,
          },
          {
            name: "不良(>0.25)",
            type: "area",
            data: this.chartData.poorRate,
          },
          {
            name: "スコア",
            type: "bubble",
            data: this.chartData.score,
          },
        ];
      if (this.type === "fid")
        this.series = [
          {
            name: "良好(<=100ms)",
            type: "area",
            data: this.chartData.goodRate,
          },
          {
            name: "改善の余地あり",
            type: "area",
            data: this.chartData.needsImprovementRate,
          },
          {
            name: "不良(>300ms)",
            type: "area",
            data: this.chartData.poorRate,
          },
          {
            name: "スコア",
            type: "bubble",
            data: this.chartData.score,
          },
        ];
      this.options = {
        chart: {
          id: this.type,
          type: "area",
          height: "400px",
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          events: {
            selection: function (chart: any, e: any) {
              console.log(new Date(e.xaxis.min));
            },
          },
          animations: {
            enabled: false,
          },
        },
        colors: ["#4CAF4F", "#ffba40", "#ff6c6b", "transparent"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
          curve: "smooth",
        },
        fill: {
          type: "gradient",
          gradient: {
            opacityFrom: 0.6,
            opacityTo: 0.8,
          },
        },
        legend: {
          show: false,
        },
        markers: {
          showNullDataPoints: false,
        },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }: any) {
            let title = w.globals.tooltip.tooltipTitle.outerHTML;
            let score = series[3][dataPointIndex];
            if (score === null) {
              score = "--";
            } else if (w.config.chart.id === "lcp" || w.config.chart.id === "fcp") {
              score = score + "s";
            } else if (w.config.chart.id === "fid") {
              score = score + "ms";
            }
            let threshold =
              "<div style='padding: 8px; font-size: 13px; font-weight: bold'>スコア:  " +
              score +
              "</div>";
            let items = "";
            w.globals.tooltip.ttItems.forEach((x: any, index: number) => {
              if (index === 3) return;
              let item = x.outerHTML;
              item = item.replaceAll("null%", "--%");
              items = items + item;
            });
            return title + threshold + items;
          },
        },
        xaxis: {
          categories: this.chartData.date,
        },
        yaxis: {
          max: 100,
          labels: {
            formatter: (value: number) => {
              return value + "%";
            },
          },
        },
        annotations: {
          position: "front",
          yaxis: [
            {
              y: 75,
              strokeDashArray: 0,
              borderColor: "#000",
              label: {
                borderColor: "#fff",
                borderRadius: 3,
                style: {
                  color: "#333",
                  background: "#fff",
                  fontSize: "12px",
                },
                text: "しきい値",
                orientation: "horizontal",
                offsetX: -8,
                offsetY: -8,
                cssClass: "apexcharts-xaxis-annotation-label",
              },
            },
          ],
        },
      };
    },
  },
  watch: {
    chartData() {
      this.updateData();
    },
  },
});
